import { replace } from 'connected-react-router';
import throttle from 'lodash.throttle';
import {
    ACTION_INITIATED_LOCAL_REP,
    GO_NEXT_ACTION,
    IS_NEXT_ACTION_TRANSITION,
    SET_ACTIVE_ACTION_FROM_ACTION_CHOICE
} from '../Widget/actions';

export const ACTION_CHOICE_BEGIN_ACTION = 'ACTION_CHOICE_BEGIN_ACTION';
export const ACTION_CHOICE_CAROUSEL_BACK = 'ACTION_CHOICE_CAROUSEL_BACK';
export const ACTION_CHOICE_CAROUSEL_FORWARD = 'ACTION_CHOICE_CAROUSEL_FORWARD';
export const ACTION_CHOICE_CLEAR_ACTION = 'ACTION_CHOICE_CLEAR_ACTION';
export const ACTION_CHOICE_SET_ACTIVE_ACTION_FROM_SWIPE = 'ACTION_CHOICE_SET_ACTIVE_ACTION_FROM_SWIPE'; //eslint-disable-line
export const LOCAL_REP_GO_TO_FIND_SCREEN = 'LOCAL_REP_GO_TO_FIND_SCREEN';
export const SET_CHOICE_PARTNER = 'SET_CHOICE_PARTNER';

const scrollCarousel = throttle((direction, dispatch) => {
    if (direction === 'next'){
        dispatch({
            type: ACTION_CHOICE_CAROUSEL_FORWARD
        });
    } else {
        dispatch({
            type: ACTION_CHOICE_CAROUSEL_BACK
        });
    }
}, 700)

export const carouselPrev = () => dispatch => {
    scrollCarousel('back', dispatch);
};

export const carouselNext = () => dispatch => {
    scrollCarousel('next', dispatch);
};

export const setChoicePartner = partner => dispatch => {
    dispatch({
        type: SET_CHOICE_PARTNER,
        payload: partner
    })
}

export const goToFindLocalRep = actionIdentifier => dispatch => {
    dispatch({
        type: GO_NEXT_ACTION,
        payload: { actionIdentifier }
    });

    dispatch({
        type: IS_NEXT_ACTION_TRANSITION,
        payload: true
    });

    dispatch({
        type: LOCAL_REP_GO_TO_FIND_SCREEN,
        payload: actionIdentifier
    });

    setTimeout(() => {
        dispatch({
            type: ACTION_INITIATED_LOCAL_REP,
            payload: actionIdentifier
        });
    }, 1000);

    dispatch(replace('/actionChoiceCard/findRep'));
};

export const beginAction = item => dispatch => {
    dispatch({
        type: SET_ACTIVE_ACTION_FROM_ACTION_CHOICE,
        payload: { actionIdentifier: item.identifier }
    });

    dispatch({ type: ACTION_CHOICE_BEGIN_ACTION });
};
export const clearAction = () => dispatch => {
    dispatch({
        type: ACTION_CHOICE_CLEAR_ACTION
    });
};

export const selectCard = item => dispatch => {
    dispatch({
        type: ACTION_CHOICE_SET_ACTIVE_ACTION_FROM_SWIPE,
        payload: item
    });
};
